$(document).on('click', '.show-more-orders', function(e) {
	e.preventDefault();
	$(this).closest('table').find('.hidden').removeClass('hidden');
	$(this).remove();
});
$(document).on('click', '.order-table tbody tr', function(e){
	window.location.href='/account_history_info.php?order_id=' + $(this).attr('orders_id') + '&orderType=' + $(this).data('type');
});